import { render, staticRenderFns } from "./RegistrationClosed.vue?vue&type=template&id=5fa06ae7&"
import script from "./RegistrationClosed.vue?vue&type=script&lang=js&"
export * from "./RegistrationClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports